import { ApplicationState } from "application/redux";
import { connect } from "react-redux";
import { fetchWifiData, onExit } from './redux/actions';
import WifiDashboardsComponent from "./wifi-dashboards-components";

const mapStateToProps = (state: ApplicationState) => ({
  general: state.devices.detail.general,
  wifi: state.devices.detail.wifi,
})

export default connect(mapStateToProps, {
  fetchWifiData,
  onExit,
})(WifiDashboardsComponent)
